/**
 * Editable editorial content. Values left as `null` are intentionally empty:
 * Nicole's biography, age, career and awards must never be invented.
 */
export const brand = {
  name: 'NICOLE',
  slogan: 'Cada historia tiene su universo',
};

export const aboutContent: {
  portraitUrl: string | null;
  portraitAlt: string;
  introduction: string | null;
  vision: string | null;
} = {
  portraitUrl: null,
  portraitAlt: 'Retrato de Nicole',
  introduction: null,
  vision: null,
};

export const professionalContact: { email: string | null } = {
  email: null,
};
